module.exports = __webpack_public_path__ + "img/status-eveywhere.6a324603.png";